<template>
  <div class="row mt-5">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER'"
              :to="{ name: 'assistedLivingCoachingInvitationToFirstAppointmentList', params: { id: coaching.id } }"
              :class="{ active: $route.name === 'assistedLivingCoachingInvitationToFirstAppointmentList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Einladungsschreiben
          </router-link>

          <router-link
              :to="{ name: 'assistedLivingCoachingFirstInterviewForm', params: { id: coaching.id } }"
              :class="{ active: $route.name === 'assistedLivingCoachingFirstInterviewForm' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true">
            Erstgespräch
          </router-link>

          <router-link
              :to="{ name: 'assistedLivingCoachingProtocolList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'assistedLivingCoachingProtocolList' }"
              aria-controls="nav-profile"
              aria-selected="false">
            Sitzungsprotokolle
          </router-link>

          <router-link
              :to="{ name: 'assistedLivingCoachingCoachingWeeklyPlan', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'assistedLivingCoachingCoachingWeeklyPlan' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Wochenplan & Notfallplan
          </router-link>

          <router-link
              :to="{ name: 'assistedLivingCoachingInterimReportList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'assistedLivingCoachingInterimReportList' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Zwischenbericht
          </router-link>

          <router-link
              :to="{ name: 'assistedLivingCoachingFinalInterviewForm', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'assistedLivingCoachingFinalInterviewForm' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Abschlussgespräch
          </router-link>

          <router-link
              :to="{ name: 'assistedLivingCoachingDocumentsForm', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'assistedLivingCoachingDocumentsForm' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Dokumente
          </router-link>

          <router-link
              v-if="isDigitalSignature"
              :to="{ name: 'assistedLivingCoachingCoachingMeetingList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'assistedLivingCoachingCoachingMeetingList' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Anwesenheitsliste monatlich
          </router-link>

          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_ASSISTANT_VQ' ||
                  currentUserRole === 'ROLE_ACCOUNTANT' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES'"
              :to="{ name: 'assistedLivingCoachingCoachingInvoiceDocuments', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'assistedLivingCoachingCoachingInvoiceDocuments' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
             Abrechnung
          </router-link>

        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  currentUser: {
    type: Object,
    required: true,
  },
});

const coaching           = toRefs(props)[ 'coaching' ];
const currentUser        = toRefs(props)[ 'currentUser' ];
const currentUserRole    = currentUser?.value?.roles[ 0 ];
const isDigitalSignature = coaching.value.digitalSignature;
</script>

<style scoped>

</style>